import { SxProps, Theme, Typography, TypographyProps } from "@mui/material";
import React from "react";

type TextProps = {
  italic?: boolean;
  ellipsis?: number;
} & TypographyProps;

const Text = React.forwardRef<HTMLSpanElement, TextProps>(
  ({ italic, ellipsis, sx, ...props }, ref) => {
    const getEllipsisSx = (rows: number): SxProps<Theme> => {
      return {
        display: "-webkit-box",
        WebkitLineClamp: rows,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
      };
    };
    const mergedSx: SxProps<Theme> = [
      ...(Array.isArray(sx) ? sx : [sx]),
      {
        fontStyle: italic ? "italic !important" : "normal",
        ...(ellipsis ? getEllipsisSx(ellipsis) : {}),
      },
    ];

    return (
      <Typography
        ref={ref}
        sx={mergedSx}
        {...props}
      >
        {props.children}
      </Typography>
    );
  }
);

export default Text;
